import { PostData, GetData, PatchData } from "@/utils/roi.request";
import { commonConfigs } from '@/service/request.type';

export const getFlowDataOfAllDay = (params: any) => PostData(`/googleads/fetch/campaignData`, params, commonConfigs);
// 获取域名列表
export const getRoiData = (params: any) => PostData(`/googleads/find`, params, commonConfigs);
// 修改广告状态
export const changeSeriesAdStatus = (params: any) => PostData(`/api/campaign/operation/status/update`, params, commonConfigs);
// 暂停并保存Google广告系列
export const pauseAndSaveGoogleCampaigns = (params: any) => PostData(`/api/campaign/operation/pause-save`, params, commonConfigs);
// 查询Google暂停广告系列
export const getGooglePausedCampaigns = (params: any) => PostData(`/api/campaign/operation/paused-campaigns`, params, commonConfigs);
// 恢复暂停保存的Google广告系列
export const restoreGooglePausedCampaigns = (params: any) => PostData(`/api/campaign/operation/paused-campaigns/restore`, params, commonConfigs);
// 删除所选广告
export const removeAds = (params: any) => PostData(`/api/campaign/operation/remove-campaign`, params, commonConfigs);
//同步所选广告
export const asyncAds = (params: any) => PostData(`/api/campaign/operation/sync-group-bids-to-campaign`, params, commonConfigs);
// 请求站点列表(google)
export const getSitesData = () => PostData(`/googleads/list/site`);
// 请求站点列表(facebook)
export const getSitesDataForFacebook = () => PostData(`/fb/list/site`);
// 修改数据
export const updateAdsData = (params: any) => PostData(`/api/campaign/operation/budgetAndBid/update`, params, commonConfigs);
// 修改广告系列的campaignName
export const updateAdsCampaignName = (params: any) => PostData(`/api/campaign/operation/campaign/name/update`, params, commonConfigs);
// 批量更新广告系列名称
export const updateAdsCampaignNameBatch = (params: any) => PostData(`/api/campaign/operation/campaign/name/update/batch`, params, commonConfigs);
// 修改广告系列的CountryCode
export const updateAdsCountryCode = (params: any) => PostData(`/api/campaign/operation/campaig/country/update`, params, commonConfigs);
// 修改广告系列的channel
export const updateAdsChannel = (params: any) => PostData(`/api/campaign/operation/campaign/finalUrl/update`, params, commonConfigs);
//修改转换事件
export const updateConversionEvent = (params: any) => PostData(`/api/campaign/operation/campaign/conversion-goals/update`, params, commonConfigs);
// 获取snap全天买量数据
export const getSnapFlowDataOfAllDay = (params: any) => GetData(`/api/snap/data/fetch`, params, commonConfigs);
// 查询拒登广告列表
export const getRefusedAds = (siteName: string) => GetData(`/api/campaign/operation/disapproved/ads/${siteName}`);
// 批量删除拒登广告
export const removeRefusedAds = (params: any) => PostData(`/api/campaign/operation/remove-ad`, params, commonConfigs);

// 保存参数配置
export const saveParamsConfig = (params: any) => PostData(`/api/google-adjust-price/filter-configs`, params, commonConfigs);
//获取参数配置列表
export const getConfigList = (userId: string) => GetData(`/api/google-adjust-price/filter-configs/list/${userId}`);
//删除指定配置
export const deleteConfig = (params: any) => PostData(`/api/google-adjust-price/filter-configs/batchDelete`, params, commonConfigs);
//修改配置名称
export const modifyConfigName = (params: any) => PostData(`/api/google-adjust-price/filter-configs/update-name`, params);
